import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetSurvey } from "../../../apis/actions/survey.actions";
import SurveyOverview from "../../../components/survey/SurveyOverview";
import { setTargeted, setType } from "../../../apis/slices/surveySlice";
interface Props {
  targeted: any;
}
const Survey = ({ targeted }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { survey } = useSelector((state: RootState) => state?.survey);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(toGetSurvey(targeted));
    dispatch(setTargeted(targeted));
    dispatch(setType("internal"));
    setTimeout(() => setLoading(false), 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return (
    <>
      <SurveyOverview survey={survey} loading={loading} />
    </>
  );
};

export default Survey;
